var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinsSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6668 8.19824C11.9669 6.45911 12.9082 4.89571 14.3048 3.81681C15.7014 2.73792 17.4519 2.22197 19.2104 2.37086C20.9689 2.51974 22.6077 3.32265 23.8031 4.621C24.9984 5.91935 25.6635 7.61875 25.6668 9.38357C25.6666 11.0478 25.0777 12.6583 24.0044 13.9302C22.9311 15.2021 21.4425 16.0534 19.802 16.3334M2.3335 10.5001C2.3335 6.63024 5.46366 3.50007 9.3335 3.50007L8.33366 5.49974M25.6668 17.5001C25.6668 21.3699 22.5367 24.5001 18.6668 24.5001L19.6667 22.5004M9.3335 25.6667C11.19 25.6667 12.9705 24.9292 14.2832 23.6165C15.596 22.3037 16.3335 20.5233 16.3335 18.6667C16.3335 16.8102 15.596 15.0297 14.2832 13.717C12.9705 12.4042 11.19 11.6667 9.3335 11.6667C7.47698 11.6667 5.6965 12.4042 4.38375 13.717C3.07099 15.0297 2.3335 16.8102 2.3335 18.6667C2.3335 20.5233 3.07099 22.3037 4.38375 23.6165C5.6965 24.9292 7.47698 25.6667 9.3335 25.6667Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsSwap);
export default __webpack_public_path__ + "static/media/coins-swap.f3ded7f56bd381ce273e69b952277f78.svg";
export { ForwardRef as ReactComponent };